// src/utils/paxUtils.js
export const getPaxData = (nb_pax) => {
    switch (nb_pax) {
        case "sup":
            return { adults: 9, children: 0, babies: 0, total: 9 };
        case 22:
        case "22":
            return { adults: 2, children: 2, babies: 0, total: 4 };
        default:
            return { adults: parseInt(nb_pax || 1, 10), children: 0, babies: 0, total: Math.floor(nb_pax) };
    }
};
export const sommePax = (nb_pax) => {
    return Math.floor(nb_pax.adults) + Math.floor(nb_pax.children) + Math.floor(nb_pax.babies);
};
